export default {
  title: 'Dashboard',
  loadingStatus: 'Loading data',
  syncedStatus: 'Data synced',
  refresh: 'Refresh',
  notRefreshed: 'Not refreshed yet',
  lastRefreshedAt: 'Last refreshed at {time}',
  todayScanCount: 'Today Scans',
  todayNewMembers: 'Today New Members',
  totalScanCount: 'Total Scans',
  totalMembers: 'Total Members',
  ratioUp: 'MoM ↑ {value}%',
  quickActions: 'Quick Actions',
  actionProducts: 'Products',
  actionCodeDisable: 'Code Disable',
  actionActivity: 'Activities',
  actionMemberList: 'Member List',
  actionPointsMall: 'Points Mall',
  scanTrend: 'Scan Trend',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  realtimeScanRecords: 'Realtime Scan Records',
  scanTime: 'Scan Time',
  userName: 'User Name',
  scanRegion: 'Scan Country/Region',
  legendScanCount: 'Scan Count',
  legendScanUsers: 'Scan Users',
  legendWinners: 'Winners',
  unit: 'pcs',
};
